import {apiService} from "../api.service";

export class LocalesService {
    public async getLocales(): Promise<string[]> {
        return (await apiService.get<string[]>("locales")).data;
    }
}

export const localesService = new LocalesService();
